import * as pluralize from 'pluralize';

import drugManagementSettings from '../constants/drugManagementSettings';

export const getDrugUnitName = (plural?: boolean): string => {
    let unitName = drugManagementSettings.defaultUnit;

    if (!!plural) {
        unitName = pluralize.plural(unitName);
    }

    return unitName;
};